'use client'
import Loader from "atoms/Loader"

export default function ProgressedRecordsLoader({ processedRecords }) {
    return <Loader type="fullPage" showProcessedRecords={true} processedRecords={processedRecords} />
}
